import * as A11yDialog from 'a11y-dialog';
var lory: LoryStatic = require('lory.js').lory;

export function multimediaBlock() {
    let multimediaItems = Array.prototype.slice.call(document.querySelectorAll('[data-a11y-dialog]'));

    if (multimediaItems) {
        multimediaItems.forEach(function (item) {
            item.addEventListener('click', function () {
                let listPosition = item.getAttribute('data-list-position');

                let modalId = item.getAttribute('data-a11y-dialog');
                let modal = document.getElementById(modalId);

                (window as any)[modalId].show();

                let carousel = modal.querySelector('.multimedia-slider-js');

                if (carousel) {
                    let carouselId = carousel.getAttribute('id');

                    (window as any)[carouselId].slideTo(Number(listPosition));
                }

                let currentSlide = document.querySelector('.multimedia-item.js_slide.active');

                if (currentSlide) {
                    let currentSlidePlayBtn = currentSlide.querySelector('.home-hero-play') as HTMLElement;

                    if (currentSlidePlayBtn) {
                        currentSlidePlayBtn.click();
                    }
                }

                let carouselCounter = carousel.querySelector('.multimedia-carousel-index-js');

                if (carouselCounter) {
                    carouselCounter.innerHTML = currentSlide.getAttribute('data-index');
                }
            })
        })
    }

    // Multimedia block modals
    let multimediaModals = Array.prototype.slice.call(document.querySelectorAll('.a11y-modal-js'));

    if (multimediaModals) {
        multimediaModals.forEach(function (modal) {
            let modalClose = modal.querySelector('.multimedia-modal-close-js');

            if (modalClose) {
                modalClose.addEventListener('click', function () {
                    let currentSlide = modal.querySelector('.multimedia-item.js_slide.active');

                    if (currentSlide) {
                        let currentSlidePlayBtn = currentSlide.querySelector('.home-hero-pause') as HTMLElement;

                        if (currentSlidePlayBtn) {
                            currentSlidePlayBtn.click();
                        }
                    }

                    let modalId = modal.getAttribute('id');

                    (window as any)[modalId].hide();
                })
            }
        })
    }

    // Multimedia block carousels 
    let multimediaCarousels = Array.prototype.slice.call(document.querySelectorAll('.multimedia-slider-js'));

    if (multimediaCarousels) {
        multimediaCarousels.forEach(function (carousel) {
            let carouselId = carousel.getAttribute('id');

            if (carouselId) {
                (window as any).initCarousel(carouselId, 1, true);
            }

            let carouselPrev = carousel.querySelector('.js_prev');
            let carouselNext = carousel.querySelector('.js_next');
            let carouselCounter = carousel.querySelector('.multimedia-carousel-index-js');

            if (carouselPrev) {
                carouselPrev.addEventListener('click', function () {
                    carouselCounter.innerHTML = carousel.querySelector('.multimedia-item.js_slide.active').getAttribute('data-index');
                });
            }

            if (carouselNext) {
                carouselNext.addEventListener('click', function () {
                    carouselCounter.innerHTML = carousel.querySelector('.multimedia-item.js_slide.active').getAttribute('data-index');
                });
            }
        })
    }

    let multimediaCarouselVideos = Array.prototype.slice.call(document.querySelectorAll('.multimedia-video-js'));

    if (multimediaCarouselVideos) {
        multimediaCarouselVideos.forEach(function (video) {
            video.addEventListener('click', function () {

                let thumbnails = Array.prototype.slice.call(video.querySelectorAll('.multimedia-video-thumbnail'));
                let playButton = video.querySelector('.multimedia-play-btn');

                if (thumbnails) {
                    thumbnails.forEach(function (thumbnail) {
                        thumbnail.classList.add('multimedia-video-thumbnail-hidden');
                    })
                }

                if (playButton) {
                    playButton.classList.add('multimedia-play-btn-hidden');
                }
            })
        })
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/multimedia-block.ts